import elementStateToggle from '../../../../../../src/js/modules/elementStateToggle';
import sliderEventsTimeline from '../../../../../../src/js/modules/sliderEventsTimeline';
import sliderTabNavigation from '../../../../../../src/js/modules/sliderTabNavigation';

window.addEventListener('load', () => {
    sliderTabNavigation.init();

    const rankingElements = document.querySelectorAll('.js-ranking-element');
    rankingElements.forEach((rankingElement) => {
        elementStateToggle.init({
            triggerElementSelector: `#${rankingElement.id} .js-state-trigger`,
            preventDefault: true,
            hasContextElement: {
                elements: `#${rankingElement.id} .js-state-context`,
                attr: 'href',
            },
            toggleActiveElement: true,
            removeAllActiveClasses: true,
            hooks: {
                afterToggle: (() => {
                    if (typeof sliderEventsTimeline.sliderEventsTimeline !== 'undefined') {
                        sliderEventsTimeline.sliderEventsTimeline.forEach((element) => {
                            element.swiper.update();
                        });
                    }
                }),
            },
        });
    }).bind(this);
});
